<template>
	<div class="blink-message-wrapper">
		<div class="blink-message">
			<FallBack
				v-if="sendToBlinkError"
				:message="sendToBlinkError"
				:border="false"
				:transparentBackground="true"
				iconStyle="fal"
				icon="exclamation-triangle"
			/>
			<p
				class="blink-message-text"
				v-if="blinkUnregistered && !sendToBlinkError"
			>
				Sorry, you don't have access to Blink+. To get set up with Blink+,
				please contact your UWM account executive at
				<a class="cc-link" href="tel: 1-800-981-8898">1-800-981-8898</a>. To
				learn more about Blink+, please
				<a
					class="cc-link"
					href="https://www.uwm.com/manage-your-pipeline/blink"
					target="_blank"
					>click here</a
				>
			</p>
			<p
				class="blink-message-text"
				v-else-if="
					!blinkUnregistered && !sendToBlinkError && sendContactToBlink
				"
			>
				Are you sure you want to send
				<span class="bolded-message-text"
					>{{ leadData.firstName }} {{ leadData.lastName }}</span
				>'s information to Blink+? An automated email will be sent to
				<span class="bolded-message-text"
					>{{ leadData.firstName }} {{ leadData.lastName }}</span
				>
				at
				<span class="bolded-message-text">{{ leadData.email }}</span>
				with a link to their new Blink+ mortgage application.
			</p>
			<p
				class="blink-message-text"
				v-else-if="!blinkUnregistered && !sendToBlinkError && sendLoanInfoToBlink"
			>
				Are you sure you want to send the information for
				<span class="bolded-message-text">{{ this.leadData.address }}</span>
				to Blink+? An automated email will be sent to
				<span class="bolded-message-text"
					>{{ leadData.firstName }} {{ leadData.lastName }}</span
				>
				at
				<span class="bolded-message-text">{{ leadData.email }}</span>
				with a link to their new Blink+ mortgage application.
			</p>
		</div>
		<OverviewModalFooter
			:isSaveModal="true"
			:primaryButtonName="
				!blinkUnregistered && !sendToBlinkError ? 'Send to Blink+' : 'OK'
			"
			:waiting="waiting"
			:success="success"
			@close="$emit('handleClose')"
			@handleClick="
				!blinkUnregistered && !sendToBlinkError
					? sendToBlink()
					: $emit('handleClose')
			"
		/>
	</div>
</template>

<script>
import OverviewModalFooter from './OverviewModalFooter.vue';
import FallBack from '../../../components/global/FallBack.vue';
import leadsService from '@/services/contacts/leads-service.js';
import loansService from '@/services/contacts/loans-service.js';

export default {
	name: 'SendToBlink',
	components: {
		OverviewModalFooter,
		FallBack,
	},
	props: {
		leadId: Number,
		leadData: Object,
		blinkUnregistered: Boolean,
		sendContactToBlink: Boolean,
		sendLoanInfoToBlink: Boolean,
	},
	data() {
		return {
			waiting: false,
			success: false,
			sendToBlinkError: null,
		};
	},
	methods: {
		async sendToBlink() {
			let payload = {};

			if (this.leadData.birthday === null) {
				this.sendToBlinkError = `Please enter date of birth for ${this.leadData.firstName} ${this.leadData.lastName} in order to send this contact to Blink+`;
				return;
			}

			if (this.sendContactToBlink) {
				payload = {
					leadId: this.leadId,
				};
				this.waiting = true;
				try {
					await leadsService.sendLeadToBlink(payload);
					this.success = true;
					setTimeout(() => {
						this.$emit('leadSentToBlink');
						this.success = false;
					}, 1500);
				} catch (error) {
					this.sendToBlinkError = error;
				}
				this.waiting = false;
			} else if (this.sendLoanInfoToBlink) {
				payload = {
					loanId: this.leadData.loanId,
				};
				this.waiting = true;
				try {
					await loansService.sendLoanToBlink(payload);
					this.success = true;
					setTimeout(() => {
						this.$emit('loanSentToBlink');
						this.success = false;
					}, 1500);
				} catch (error) {
					this.sendToBlinkError = error;
				}
				this.waiting = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.blink-message-wrapper {
	.blink-message {
		@include rem('padding', 20px);
	}

	p.blink-message-text {
		margin: 0;
		padding: 0;
		@include rem('line-height', 25px);
	}

	.cc-link {
		@include typo--roboto__medium;
		color: $brand-blue;
		text-decoration: none;
	}
}

.bolded-message-text {
	@include typo--roboto__bold;
}
</style>
